'use client';

import { useSession } from 'next-auth/react';

import { useNavigate } from 'hooks/useNavigation';

import { RequestResetPassword } from '@components/RequestResetPassword';

export default function RequestResetPasswordPage() {
  const { status } = useSession();

  const { goToPath } = useNavigate();

  if (status === 'authenticated') {
    goToPath('/assignments');
  }

  return <RequestResetPassword activate={false} />;
}
